// extracted by mini-css-extract-plugin
module.exports = {"shareCard":"shareat_shareCard__39JQ3","title":"shareat_title__kWX50","icon":"shareat_icon__HLw_m"};